import { Fieldset } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Day } from './day';
import { DaysContainer } from './styles';
const fieldsetContainerIsTabletUpCss = "f71325o";
const fieldsetContainerIsDesktopUpCss = "f1yemxm6";
const fieldsetContainerCss = "fuxstsq";
const FieldsetContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <Component ref={ref} {...restProps} className={classNames(fieldsetContainerCss, {
    [fieldsetContainerIsTabletUpCss]: isTabletUp,
    [fieldsetContainerIsDesktopUpCss]: isDesktopUp
  }, props.className)} />;
});
const titleWrapperCss = "t12ljcnz";
const TitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'legend';
  return <Component ref={ref} {...restProps} className={classNames(titleWrapperCss, props.className)} />;
});
export const DaysView = ({
  displayLegend,
  days,
  handleCheckboxClick,
  setWdayIntervals,
  cloneWeekdayAvailability,
  className,
  alwaysAbbreviate = false,
  allowCopy = true,
  allowCopyUnavailable = true,
  redesignStyling = false,
  v4Styling = false
}) => <FieldsetContainer data-component="days-container" className={className}>
    <Fieldset>
      {displayLegend && <TitleWrapper>
            <TitleText size="medium" level={3}>{I18n.t('publisher.availability.schedules.weekly_hours')}</TitleText>
          </TitleWrapper>}
      <DaysContainer>
        {Object.keys(days).map(wday => <Day allowCopy={allowCopy} allowCopyUnavailable={allowCopyUnavailable} alwaysAbbreviate={alwaysAbbreviate} key={wday} wday={wday} days={days} handleCheckboxClick={handleCheckboxClick} setWdayIntervals={setWdayIntervals} cloneWeekdayAvailability={cloneWeekdayAvailability} redesignStyling={redesignStyling} v4Styling={v4Styling} />)}
      </DaysContainer>
    </Fieldset>
  </FieldsetContainer>;

require("./days_view.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./days_view.js");